export default __webpack_public_path__ + "static/media/check-green.0f9a85eb.svg";